import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Service } from '../data/services';
import { ArrowRight } from 'lucide-react';
interface ServiceCardProps {
  service: Service;
  featured?: boolean;
}
export function ServiceCard({
  service,
  featured = false
}: ServiceCardProps) {
  const Icon = service.icon;
  return <motion.div whileHover={{
    y: -8,
    scale: 1.02
  }} className={`relative group rounded-3xl overflow-hidden transition-all duration-500 h-full flex flex-col ${featured ? 'glass border-gold/30 shadow-[0_0_30px_rgba(212,175,110,0.15)]' : 'glass hover:border-gold/50'}`} data-id="element-170">
      {/* Premium Badge */}
      {service.isPremium && !featured && <div className="absolute top-6 right-6 bg-gold/10 text-gold text-[10px] font-bold tracking-widest uppercase px-3 py-1 rounded-full border border-gold/20 z-10" data-id="element-171">
          Premium
        </div>}

      <div className="p-8 flex-grow flex flex-col relative z-10" data-id="element-172">
        <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-8 transition-all duration-500 relative ${featured ? 'bg-gold/10 text-gold' : 'bg-white/5 text-white group-hover:bg-gold group-hover:text-midnight'}`} data-id="element-173">
          <div className="absolute inset-0 rounded-full blur-md bg-current opacity-20 group-hover:opacity-40 transition-opacity" data-id="element-174"></div>
          <Icon className="w-8 h-8 relative z-10" data-id="element-175" />
        </div>

        <h3 className="text-2xl font-serif mb-4 text-white group-hover:text-gold transition-colors" data-id="element-176">
          {service.title}
        </h3>

        <p className="mb-8 text-beige-muted text-sm leading-relaxed flex-grow" data-id="element-177">
          {service.shortDescription}
        </p>

        <div className="flex items-center gap-4 text-xs font-bold uppercase tracking-widest text-gold mb-8" data-id="element-178">
          <span data-id="element-179">{service.duration}</span>
          <span className="w-1 h-1 rounded-full bg-gold/50" data-id="element-180"></span>
          <span data-id="element-181">${service.price}</span>
        </div>

        <Link to={`/services/${service.slug}`} className="inline-flex items-center gap-2 text-sm font-medium text-white group-hover:text-gold transition-colors mt-auto" data-id="element-182">
          Learn More{' '}
          <ArrowRight className="w-4 h-4 group-hover:translate-x-2 transition-transform" data-id="element-183" />
        </Link>
      </div>

      {/* Subtle background decoration */}
      <div className="absolute -bottom-12 -right-12 opacity-5 pointer-events-none group-hover:opacity-10 transition-opacity duration-500 group-hover:scale-110 transform" data-id="element-184">
        <Icon className="w-48 h-48 text-white" data-id="element-185" />
      </div>
    </motion.div>;
}